<mat-drawer-container class="drawer-container" [dir]="direction">
  <div>
    <div class="app-container">
      <app-breadcrumb/>
      <div class="main-body">
        <div class="page-wrapper">
          <router-outlet />
          <app-loading-overlay></app-loading-overlay>

        </div>
      </div>
    </div>
  </div>
</mat-drawer-container>
<app-configuration />

